import { asyncLoad } from '@util'

/**
 * @author  Ta_Mu
 * @date 2021/5/13 14:42
 */
export default [
  {
    path: 'upgradeService',
    component: asyncLoad(() =>
      import('@components/LocalMerchant/UpgradeService')
    ),
    indexRoute: {
      onEnter(ns, replace) {
        replace('/localMerchant/upgradeService/home')
      }
    },
    childRoutes: [
      {
        path: 'home',
        component: asyncLoad(() =>
          import('@components/LocalMerchant/UpgradeService/Home')
        )
      },
      {
        path: 'edit(/:id)',
        component: asyncLoad(() =>
          import('@components/LocalMerchant/UpgradeService/Edit')
        )
      },
      {
        path: 'reviewRecord',
        component: asyncLoad(() =>
          import('@components/LocalMerchant/UpgradeService/ReviewRecord')
        )
      }
    ]
  }
]
